"use strict";

exports.__esModule = true;
exports.isErrorPage = exports.ERROR_PAGES = exports.STATUS_CONFLICT = exports.STATUS_INTERNAL_SERVER_ERROR = exports.STATUS_NOT_FOUND = void 0;
var STATUS_NOT_FOUND = 404;
exports.STATUS_NOT_FOUND = STATUS_NOT_FOUND;
var STATUS_INTERNAL_SERVER_ERROR = 500;
exports.STATUS_INTERNAL_SERVER_ERROR = STATUS_INTERNAL_SERVER_ERROR;
var STATUS_CONFLICT = 409;
exports.STATUS_CONFLICT = STATUS_CONFLICT;
var ERROR_PAGES = [STATUS_NOT_FOUND, STATUS_INTERNAL_SERVER_ERROR];
exports.ERROR_PAGES = ERROR_PAGES;

var isErrorPage = function isErrorPage(pathname) {
  return ERROR_PAGES.includes(Number(pathname));
};

exports.isErrorPage = isErrorPage;